// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import {
    formFieldDescriptionWrapperStyles,
    formFieldInputSelectDisabledStyles,
    formFieldInputSelectIconStyles,
    formFieldLabelStyles,
    formFieldVariantStyles,
} from "@store/Themes/common/mixins/formField";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { css } from "styled-components";

/* Store Custom Code - Start */
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
/* Store Custom Code - End */

/* ------------------------------------------------------------------------------------------ */
/* Related Extensions => src/Extensions/Mobius/FormField ------------------------------------ */
/* ------------------------------------------------------------------------------------------ */

const formField: Styleguide["formField"] = {
    defaultProps: {
        border: "rounded",
        backgroundColor: "common.background",
        labelProps: {
            css: formFieldLabelStyles(),
        },
        errorProps: {
            color: "#52535A", // Store Custom Code
            size: "inherit",
            weight: "normal", // Store Custom Code
            // Store Custom Code
            css: css`
                background-color: #f5e8ea;
                border-radius: 8px;
                padding: ${pxToRem(8, 16)};
            `,
        },
        hintProps: {
            color: "text", // Store Custom Code
            size: "inherit",
            weight: "normal",
        },
        cssOverrides: {
            inputSelect: css`
                ${formFieldVariantStyles()}
                ${formFieldInputSelectIconStyles("primary", "primary.dark")}
                ${formFieldInputSelectDisabledStyles("text.disabled", "common.disabled")}
                color: ${getColor("text.input")};
                /* Store Custom Code - Start */
                transition: ${transitionHoverStyles("primary.dark")};
                &:hover {
                    border-color: ${getColor("primary.dark")};
                }
                /* Store Custom Code - End */
            `,
            descriptionWrapper: formFieldDescriptionWrapperStyles(),
        },
    },
};

export default formField;
